import { tools } from '@/utils/tools';
import { cloneDeep } from 'lodash';

/**
 * @brief 新建编辑重构涉及方法
 * @return
 */
export default function useFhForm() {
  const convertModule2Data = (moduleItem) => {
    const convertResult = {};
    if (moduleItem?.length) {
      moduleItem?.forEach((m) => {
        let _fv = null;
        if (m?.setting?.fieldType == 0) {
          _fv = m?.fieldValue;
        }
        convertResult[m.fieldKey] = _fv;
      });
    }

    return convertResult;
  };

  const formatModuleFieldValue = (module, fieldValue) => {
    const _module = cloneDeep(module);
    const fieldType = module?.setting?.fieldType == 21 ? module?.setting?.business?.fieldType : module?.setting?.fieldType;
    const fieldExt = module?.setting?.fieldType == 21 ? module?.setting?.business?.fieldExt : module?.setting?.fieldExt;
    // 不是引用字段赋值才处理返回值
    if (module?.setting?.fieldType != 21) {
      if (fieldType == 2 || fieldType == 4) {
        //2.单选 4.下拉单选
        _module.fieldValue = fieldValue || fieldValue === 0 || fieldValue === '0' ? fieldValue : '';
      } else if (fieldType == 3 || fieldType == 5) {
        //3.多选 5.下拉多选
        _module.fieldValue = fieldValue ? fieldValue.split(',') : [];
      } else if (fieldType == 6) {
        //6.人员
        const _user = [];
        const _name = [];
        const _list = fieldValue ? (Array.isArray(fieldValue) ? fieldValue : [fieldValue]) : [];
        _list.forEach((v) => {
          _user.push({
            id: v.userId || v.id || '',
            userName: v.userName,
            avatarOrigin: v.avatar || v.avatarOrigin || ''
          });
          _name.push(v.userName);
        });
        _module.setting['fv'] = {
          userList: _user,
          departList: []
        };
        _module.fieldValue = _name;
      } else if (fieldType == 7) {
        //7.数字
        _module.fieldValue = fieldValue ? Number(parseFloat(fieldValue)) : '';
      } else if (fieldType == 8) {
        //8.日期
        _module.fieldValue = fieldValue;
      } else if (fieldType == 9) {
        //9.日期范围
        if (tools.isJSON(fieldValue) && JSON.parse(fieldValue)?.beginDate && JSON.parse(fieldValue)?.endDate) {
          _module.fieldValue = [JSON.parse(fieldValue)?.beginDate, JSON.parse(fieldValue)?.endDate];
        } else {
          _module.fieldValue = null;
        }
      } else if (fieldType == 10) {
        //10.级联选择器
        _module.fieldValue = fieldValue ? fieldValue.split('/') : [];
      } else if (fieldType == 12) {
        //12.查找关联
        if (fieldValue?.label && fieldValue?.value) {
          _module.fieldValue = fieldValue?.value;
          //兼容查找关联单选反显
          _module['fieldValueName'] = fieldValue?.label;
        } else {
          _module.fieldValue = fieldValue;
          _module['fieldValueName'] = fieldValue;
        }
      } else if (fieldType == 16) {
        //16.金额
        _module.fieldValue = tools.getPrice(fieldValue, fieldExt ? fieldExt : 2);
      } else if (fieldType == 18) {
        //18.附件
        _module.fieldValue = fieldValue && tools.isJSON(fieldValue) ? JSON.parse(fieldValue) : [];
      } else if (fieldType == 22) {
        //22.部门
        const _depart = [];
        const _name = [];
        const _list = fieldValue ? (Array.isArray(fieldValue) ? fieldValue : [fieldValue]) : [];
        _list.forEach((v) => {
          _depart.push({
            id: v.departmentId || v.id || '',
            departmentName: v.departmentName || v.name || ''
          });
          _name.push(v.departmentName || v.name || '');
        });
        _module.setting['fv'] = {
          departList: _depart,
          userList: []
        };
        _module.fieldValue = _name;
      } else if (fieldType == 23) {
        //23.百分比
        _module.fieldValue = tools.getPercentage(fieldValue, JSON.parse(fieldExt)?.numberFormat || 2);
      } else if (fieldType == 24) {
        //计算类型
        if (tools.isJSON(fieldExt)) {
          const getFieldExt = JSON.parse(fieldExt);
          if (getFieldExt?.type === 6 || getFieldExt?.type === 16) {
            // 6:汇总金额类型  16：金额
            _module.fieldValue = !isNaN(parseFloat(fieldValue)) ? tools.getPrice(fieldValue, getFieldExt?.dataType) : '';
          } else if (getFieldExt?.type === 23) {
            //百分比
            _module.fieldValue = !isNaN(parseFloat(fieldValue)) ? tools.getPercentage(fieldValue, getFieldExt?.dataType) : '';
          } else if (getFieldExt?.type === 5 || getFieldExt?.type === 7) {
            //数字
            _module.fieldValue = !isNaN(parseFloat(fieldValue)) ? Number(parseFloat(fieldValue).toFixed(getFieldExt?.dataType)) : '';
          } else {
            _module.fieldValue = fieldValue ?? '';
          }
        }
      } else if (fieldType == 25) {
        //25.查找关联多选
        if (fieldValue?.[0]?.label && fieldValue?.[0]?.value) {
          _module.fieldValue = fieldValue?.map((v) => v?.value);
          //兼容查找关联单选反显
          _module['fieldValueName'] = fieldValue?.map((v) => v?.label);
        } else {
          _module.fieldValue = fieldValue;
        }
      } else {
        _module.fieldValue = fieldValue;
      }
    } else {
      //   引用字段直接赋值
      _module.fieldValue = fieldValue;
    }

    return _module;
  };

  /**
   * @brief 获取两个id数组中的交集和差集
   * @param arr1
   * @param arr2
   * @return a集合相较于b集合多的部分和少的部分
   * @example a:[1, 2, 3] b:[2, 3, 4] return { del: [1], add: [4] }
   */
  const getTableIdDiff = (arr1, arr2) => {
    const difference = (a, b) => {
      const setArr = new Set(b);
      return a.filter((x) => !setArr.has(x));
    };

    return {
      add: difference(arr1, arr2),
      del: difference(arr2, arr1)
    };
  };

  /**
   * @brief 获取上送需要的字段值
   * @param list
   * @param isText 查找关联是否使用label文本
   */
  const getFormFieldValue = (list, isText = false) => {
    let fieldValue = list?.fieldValue;
    const fieldType = list.setting.fieldType == 21 ? list?.setting?.business?.fieldType : list.setting.fieldType;
    const fieldExt = list.setting.fieldType == 21 ? list?.setting?.business?.fieldExt : list.setting.fieldExt;
    if (fieldType === 3 || fieldType === 5) {
      fieldValue = fieldValue && Array.isArray(fieldValue) ? fieldValue?.join(',') : null;
    } else if (fieldType === 6) {
      //人员传递参数是字符串ID以逗号分割
      const userIds = list.setting?.fv?.userList?.map((u) => u.id)?.join(',');
      fieldValue = userIds || '';
    } else if (fieldType === 9) {
      const hasValue = tools.hasDateRange(fieldValue);
      const v = { beginDate: fieldValue?.[0], endDate: fieldValue?.[1] };
      fieldValue = hasValue ? JSON.stringify(v) : '';
    } else if (fieldType === 10) {
      fieldValue = fieldValue && Array.isArray(fieldValue) ? fieldValue?.join('/') : '';
    } else if (fieldType === 12) {
      if (isText) {
        fieldValue = {
          label: fieldValue?.label || list?.customValue?.name || list?.fieldValueName || fieldValue || '',
          value: fieldValue?.value || list?.customValue?.value || fieldValue || ''
        };
      } else {
        fieldValue = fieldValue?.value || list?.customValue?.value || fieldValue || '';
      }
    } else if (fieldType === 16) {
      fieldValue = tools.setPrice(fieldValue) || '';
    } else if (fieldType === 18) {
      fieldValue = fieldValue ? JSON.stringify(fieldValue) : '';
    } else if (fieldType === 23) {
      fieldValue = fieldValue ? tools.setPercentage(fieldValue) : null;
    } else if (fieldType === 22) {
      //部门传递参数是字符串ID以逗号分割
      const departIds = list.setting?.fv?.departList?.map((u) => u.id)?.join(',');
      fieldValue = departIds || '';
    } else if (fieldType === 24) {
      //计算类型
      if (fieldExt && tools.isJSON(fieldExt)) {
        if (JSON.parse(fieldExt)?.type == 6 || JSON.parse(fieldExt)?.type == 16) {
          //6：汇总金额  16：金额
          fieldValue = tools.setPrice(fieldValue) || '';
        } else if (JSON.parse(fieldExt)?.type == 23) {
          //百分比
          fieldValue = fieldValue ? tools.setPercentage(fieldValue, JSON.parse(fieldExt)?.dataType) : '';
        }
      }
    } else if (fieldType === 25) {
      fieldValue = list?.customValue?.[0]?.label ? list?.customValue?.map((v) => v.label)?.join(',') : list?.fieldValueName?.length > 0 ? list?.fieldValueName?.join(',') : null;
    } else {
      fieldValue = list?.fieldValue;
    }

    return fieldValue;
  };

  /**
   * @brief 获取上送接口的表单值（key=>value格式）
   * @params formData 外部调用时传formData
   * @params isText 查找关联是否使用label文本
   */
  const getSendData = (formData = null, isText = false) => {
    const sendData = {};
    formData?.forEach((item) => {
      if (item?.modules) {
        item?.modules.forEach((list) => {
          if (list.type == 20) {
            sendData[list?.setting?.fieldKey] = getFormFieldValue(list, isText);
          }
        });
      }
    });

    return sendData;
  };

  /**
   * @brief 判断fieldValue是否为空
   * @param fieldValue 字段值
   * @param fieldType 字段类型
   * @return boolean
   */
  const isEmptyFieldValue = (fieldValue, fieldType) => {
    let isEmpty = false;
    if (fieldType === 24) {
      isEmpty = false;
    } else if (fieldValue == null) {
      isEmpty = true;
    } else if (fieldValue === 0) {
      isEmpty = false;
    } else if (typeof fieldValue === 'string' || Array.isArray(fieldValue)) {
      return !fieldValue?.length;
    } else if (typeof fieldValue === 'object') {
      isEmpty = !Object.keys(fieldValue)?.length;
    }

    return isEmpty;
  };

  return {
    convertModule2Data,
    formatModuleFieldValue,
    getTableIdDiff,
    getSendData,
    isEmptyFieldValue
  };
}
